import { format } from '@utils/string';
import { getAreaURL } from '@services/urls/apiURLs';
import { getCountryId } from '@shared/selectors';

const fetchArea = ({ latitude, longitude }) => async (
  dispatch,
  getState,
  axios,
) => {
  try {
    const state = getState();
    const countryId = getCountryId(state);
    if (!countryId || !latitude || !longitude)
      throw new Error('countryId, latitude and longitude are required');
    const url = format(getAreaURL, countryId, latitude, longitude);
    const { data } = await axios.get(url);

    return {
      id: data.areaId,
      name: data.areaName,
    };
  } catch (error) {
    throw new Error(error);
  }
};

export default fetchArea;
